import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import thunk from 'redux-thunk'
import authReducer from './authSlice'
import logger from 'redux-logger';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import gstinSlice from './gstinSlice'
import propertyRegData from './propertyRegistrationSlice'
import permissions from './permissions'
import getInvoiceByEmail from './getInvoiceByEmailSlice'

const reducers = combineReducers({
  auth: authReducer,
  gstinData: gstinSlice,
  propertyRegData: propertyRegData,
  permissionsData: permissions,
  getInvoiceByEmail: getInvoiceByEmail
})


const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, reducers)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      logger
    }),
})
